import cn from 'classnames';
import React from 'react';

import ArrowRight from '@sats-group/icons/24/arrow-right';
import Text from '@sats-group/ui-lib/react/text';

import { type ArrowButton as Props } from './arrow-button.props';

const ArrowButton: React.FunctionComponent<Props> = ({
  color,
  onClick = () => {},
  noBorder = false,
  popoverTarget,
  title,
}) => (
  <button
    className={cn('arrow-button', {
      'arrow-button--no-border': noBorder,
    })}
    onClick={onClick}
    popoverTarget={popoverTarget ?? undefined}
  >
    <div
      className={cn('arrow-button__text', {
        [`arrow-button__text--${color}`]: color,
      })}
    >
      <Text>{title}</Text>
    </div>
    <ArrowRight />
  </button>
);

export default ArrowButton;
